import { Moment } from 'moment';
import * as yup from 'yup';

const baseValidationScheme = yup.object({
	dateFrom: yup.date().required('validation.calendarAbsenceEvent.dateFrom'),
	dateTo: yup.date().required('validation.calendarAbsenceEvent.dateTo'),
	timeFrom: yup.date().when('wholeDay', {
		is: false,
		then: yup
			.date()
			.typeError('validation.calendarAbsenceEvent.timeFrom')
			.required('validation.calendarAbsenceEvent.timeFrom'),
		otherwise: yup.date().notRequired(),
	}),
	timeTo: yup.date().when(['wholeDay', 'timeFrom'], {
		is: (wholeDay: boolean, timeFrom: Moment) => !wholeDay && !!timeFrom,
		then: yup
			.date()
			.typeError('validation.calendarAbsenceEvent.timeTo')
			.required('validation.calendarAbsenceEvent.timeTo')
			.test(
				'isAfterTimeFrom',
				'validation.calendarAbsenceEvent.timeToAfterTimeFrom',
				function (timeTo) {
					const { timeFrom } = this.parent;
					return !timeTo || !timeFrom || timeTo > timeFrom;
				},
			),
		otherwise: yup.date().notRequired(),
	}),
	reason: yup.string().required('validation.calendarAbsenceEvent.reason'),
	wholeDay: yup.boolean().required(),
	allowContactInAbsence: yup.boolean().required(),
});

const workplaceMemberAbsenceBaseValidationScheme = yup.object({
	workplaceMember: yup
		.object({
			value: yup
				.string()
				.uuid()
				.required('validation.calendarAbsenceEvent.workplaceMember'),
			label: yup.string(),
		})
		.required('validation.calendarAbsenceEvent.workplaceMember'),
});

const workplaceMemberAbsenceUpdateValidationScheme = yup.object({
	...baseValidationScheme.fields,
	...workplaceMemberAbsenceBaseValidationScheme.fields,
	workplaces: yup.mixed().notRequired(),
});

const workplaceMemberAbsenceCreateValidationScheme = yup.object({
	...baseValidationScheme.fields,
	...workplaceMemberAbsenceBaseValidationScheme.fields,
	workplaces: yup
		.array()
		.of(
			yup.object({
				value: yup
					.string()
					.uuid()
					.required('validation.calendarAbsenceEvent.workplaces'),
				label: yup.string(),
			}),
		)
		.min(1, 'validation.calendarAbsenceEvent.workplaces')
		.required('validation.calendarAbsenceEvent.workplaces'),
});

export const getAbsenceEventValidationScheme = (
	isEdit: boolean,
	isWorkplace: boolean,
) => {
	if (isWorkplace) {
		return baseValidationScheme;
	} else if (isEdit) {
		return workplaceMemberAbsenceUpdateValidationScheme;
	} else {
		return workplaceMemberAbsenceCreateValidationScheme;
	}
};
